import type { JSX, ReactNode } from 'react'

import { ToggleGroup } from '@buffer-mono/popcorn'

import type { TopPostsSortBy } from '../../graphqlEnums'
import { SectionCard } from '../../components/SectionCard'

import styles from './AllChannelsTopPosts.module.css'

const SORT_OPTIONS: { value: TopPostsSortBy; label: string }[] = [
  { value: 'reactions', label: 'Reactions' },
  { value: 'comments', label: 'Comments' },
]

export type TopPostsSectionViewProps = Readonly<{
  title?: string
  subtitle: ReactNode
  sortBy: TopPostsSortBy
  onSortByChange: (sortBy: 'reactions' | 'comments') => void
  sortLabel?: string
  children: ReactNode
}>

export function TopPostsSectionView({
  title = 'Top 5 Posts',
  subtitle,
  sortBy,
  onSortByChange,
  sortLabel,
  children,
}: TopPostsSectionViewProps): JSX.Element {
  return (
    <SectionCard>
      <SectionCard.Header>
        <SectionCard.Title>{title}</SectionCard.Title>
        <SectionCard.Actions>
          <ToggleGroup
            value={sortBy}
            onChange={(value: string) => {
              if (value === 'reactions' || value === 'comments')
                onSortByChange(value)
            }}
            size="medium"
            className={styles.toggleGroup}
            aria-label={sortLabel}
          >
            {SORT_OPTIONS.map((option) => (
              <ToggleGroup.Item key={option.value} value={option.value}>
                {option.label}
              </ToggleGroup.Item>
            ))}
          </ToggleGroup>
        </SectionCard.Actions>
        <SectionCard.Subtitle>{subtitle}</SectionCard.Subtitle>
      </SectionCard.Header>
      {children}
    </SectionCard>
  )
}

export function TopPostsEmptyCard({
  children,
}: Readonly<{ children: ReactNode }>): JSX.Element {
  return <div className={styles.emptyStateCard}>{children}</div>
}
